module.exports = __webpack_public_path__ + "img/what_is_a_variable.87f49327.png";